import { useNavigation } from '@eleveo/components-react';
import { EleveoEIcon } from '@eleveo/icons-react';
import React from 'react';
import { Link } from 'react-router-dom';

import { TEST_IDS } from '../../../constants/dataTestIds';
import { PATH_MAIN_ROUTE } from '../../../router/routes';

export const DrawerSideBoxHeader: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { isOpen } = useNavigation();

  return (
    <div className="drawer-header bg-black text-white leading-7">
      <Link to={PATH_MAIN_ROUTE} className="flex flex-nowrap h-full items-center">
        <span className="drawer-header__icon flex justify-center items-center flex-shrink-0">
          <EleveoEIcon />
        </span>
        <span
          className="drawer-header__text flex justify-center items-center"
          aria-hidden={!isOpen}
          data-test-id={TEST_IDS.navigationHeaderTitle}
        >
          {children}
        </span>
      </Link>
    </div>
  );
};
